import { IconButton } from '@mui/material'
import css from './EstadoAsistencia.module.css'

const EstadoAsistencia = ({ asistencia, onClick }) => {
  if (asistencia.asistencia === 'POR_DEFINIR') {
    return (
      <>
        <IconButton
          className={css.button}
          data-asistencia='VIENE'
          onClick={() => onClick('VIENE')}
        >
          <i className='material-icons'>check</i>
        </IconButton>
        <IconButton
          className={css.button}
          data-asistencia='FALTA_JUSTIFICADA'
          onClick={() => onClick('FALTA_JUSTIFICADA')}
        >
          <i className='material-icons'>highlight_off</i>
        </IconButton>
        <IconButton
          className={css.button}
          data-asistencia='FALTA'
          onClick={() => onClick('FALTA')}
        >
          <i className='material-icons'>close</i>
        </IconButton>
      </>
    )
  } else if (asistencia.asistencia === 'VIENE') {
    return (
      <IconButton
        data-asistencia='VIENE'
        onClick={() => onClick('POR_DEFINIR')}
      >
        <i className='material-icons'>check</i>
      </IconButton>
    )
  } else if (asistencia.asistencia === 'FALTA_JUSTIFICADA') {
    return (
      <IconButton
        data-asistencia='FALTA_JUSTIFICADA'
        onClick={() => onClick('POR_DEFINIR')}
      >
        <i className='material-icons'>highlight_off</i>
      </IconButton>
    )
  } else if (asistencia.asistencia === 'FALTA') {
    return (
      <IconButton
        data-asistencia='FALTA'
        onClick={() => onClick('POR_DEFINIR')}
      >
        <i className='material-icons'>close</i>
      </IconButton>
    )
  }

  return null
}

export default EstadoAsistencia
